import axios from 'axios';
import { axiosInstance } from '../Axios';

// Create an axios instance


// General error handler
const handleError = (error, apiName) => {
    console.error(`${apiName} API error:`, error?.response?.data || error.message);
    return {
        success: false,
        error: error?.response?.data || "An error occurred",
    };
};

// API Functions
export const fetchPerformanceChart = async (accountId, platform) => {
    try {
        const response = await axiosInstance.get(
            `/performance-chart/v2/${accountId}/?platform=${platform}`
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        return handleError(error, "Fetch Performance Chart");
    }
};

export const fetchAccountMetrics = async (accountId, platform) => {
    try {
        const response = await axiosInstance.get(
            `/v2/account-metrics/${accountId}/?platform=${platform}`
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        return handleError(error, "Fetch Account Metrics");
    }
};

export const fetchAccountDetails = async (accountId, platform) => {
    try {
        const response = await axiosInstance.get(
            `/v2/account-details/${accountId}/?platform=${platform}`
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        return handleError(error, "Fetch Account Details");
    }
};

export const fetchAccountObjectives = async (accountId, platform) => {
    try {
        const response = await axiosInstance.get(
            `/v2/account/objectives/${accountId}/?platform=${platform}`
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        return handleError(error, "Fetch Account Objectives");
    }
};

export const fetchAccountInsights = async (accountId, platform) => {
    try {
        const response = await axiosInstance.get(
            `/v2/account-insights/${accountId}/?platform=${platform}`
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        return handleError(error, "Fetch Account Insights");
    }
};


export const updateAccount = async (accountId, data, idToken) => {
    try {
        const response = await axiosInstance.patch(
            `/account/update/${accountId}/`,
            data,
            {
                headers: {

                    Authorization: `Bearer ${idToken}`,

                    'Content-Type': 'application/json',
                },
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        return handleError(error, "Update Account");
    }
};